module.exports = __webpack_public_path__ + "static/media/livegame.15d5507f.jpg";